import * as types from '../mutation_types';

export default {
  [types.SET_CALENDAR_TEAM](state, value) {
    state.calendar_team = value;
  }
}
